import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tile ion-activatable ripple-parent" }
const _hoisted_2 = { class: "ion-padding" }

import { IonCol, IonRippleEffect } from '@ionic/vue'

import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'TileCol',
  props: ['target'],
  setup(__props) {

const props = __props
const router = useRouter()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCol), {
    size: "6",
    "size-sm": "4",
    "size-lg": "2",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace(props.target)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createVNode(_unref(IonRippleEffect), { class: "ripple" })
      ])
    ]),
    _: 3
  }))
}
}

})